<mat-card *ngIf="!type2 && !type3">
    <div class="header">
        <span class="head shimmer">
            <b>Content head loading.. </b>
        </span>
    </div>
    <div class="content shimmer">
    </div>
</mat-card>
<div class="requestCard" *ngIf="type2">
    <div class="head">
        <span class="head shimmer"><b>Content head loading.. </b></span>
        <span class="head shimmer"><b> loading.. </b></span>
    </div>
    <div class="content2 shimmer">
    </div>
    <div class="foot">
        <span class="head shimmer"><b>Content head loading.. </b></span>
        <span class="head shimmer"><b> loading.. </b></span>
    </div>
</div>
<div *ngIf="type3" class="dashboard-card">
    <div class="count">
        <span class="shimmer" ></span>
    </div>
    <i class="flaticon-loading "></i>
    <span class="shimmer" style="height:2em; width: 100%"></span>

</div>